import { Action } from 'redux';

import { AddContentFavorite, ContentFavoriteAdded, ContentFavoriteRemoved, RemoveContentFavorite } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IFavoritableItemInfo } from '../../spacesPlatform/models/resourceInfoParts';

export interface AddContentFavoriteAction extends Action {
  item: IFavoritableItemInfo;
}

export function addContentFavorite(item: IFavoritableItemInfo): AddContentFavoriteAction {
  return {
    type: AddContentFavorite,
    item,
  };
}

export const isAddContentFavoriteAction = isActionFactory<AddContentFavoriteAction>(AddContentFavorite);

export interface ContentFavoriteAddedAction extends Action {
  item: IFavoritableItemInfo;
}

export function contentFavoriteAdded(item: IFavoritableItemInfo) {
  return {
    type: ContentFavoriteAdded,
    item,
  };
}

export const isContentFavoriteAddedAction = isActionFactory<ContentFavoriteAddedAction>(ContentFavoriteAdded);

export interface RemoveContentFavoriteAction extends Action {
  item: IFavoritableItemInfo;
}

export function removeContentFavorite(item: IFavoritableItemInfo):
    RemoveContentFavoriteAction {
  return {
    type: RemoveContentFavorite,
    item,
  };
}

export const isRemoveContentFavoriteAction = isActionFactory<RemoveContentFavoriteAction>(RemoveContentFavorite);

export interface ContentFavoriteRemovedAction extends Action {
  item: IFavoritableItemInfo;
}

export function contentFavoriteRemoved(item: IFavoritableItemInfo): ContentFavoriteRemovedAction {
  return {
    type: ContentFavoriteRemoved,
    item,
  };
}

export const isContentFavoriteRemovedAction = isActionFactory<ContentFavoriteRemovedAction>(ContentFavoriteRemoved);
